import { Component, Input } from '@angular/core';
import { ContentItem } from '@awp/content';

@Component({
  selector: 'ap-image',
  templateUrl: './image.component.html'
})
export class ImageComponent {
  @Input() image: ContentItem;
}
